module.exports = __webpack_public_path__ + "img/xj-dialog1.b722b8e4.jpg";